import { Component } from '@angular/core';
import { NavController, NavParams,Nav } from 'ionic-angular';
import { AddLogPage} from '../../add-log/add-log';
import {personModel, statsRecord} from "../../../model/personModel"
import {ShowActivityLogsPage} from "../../../pages/show-activity-logs/show-activity-logs";
import { Platform } from 'ionic-angular';
import { AngularFire, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2';
@Component({
  selector: 'page-my-dashboard',
  templateUrl: 'my-dashboard.html'
})
export class MyDashboardPage {

    constructor(
        private af: AngularFire,
        private platform: Platform,
        public navCtrl: NavController,
        public navParams: NavParams,
        public statsRecord: statsRecord        
    ) {
        
    }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MyDashboardPage');
  }

  addLog() {
      this.navCtrl.push(AddLogPage);
  }
  run() {
      console.log(this.statsRecord);
  }
  expandWeek() {
      console.log("expand called");
      this.navCtrl.push(ShowActivityLogsPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/my-dashboard/my-dashboard.ts